import { render, staticRenderFns } from "./markCenterChannel.vue?vue&type=template&id=75e1b611&scoped=true&"
import script from "./markCenterChannel.vue?vue&type=script&lang=js&"
export * from "./markCenterChannel.vue?vue&type=script&lang=js&"
import style0 from "./markCenterChannel.vue?vue&type=style&index=0&id=75e1b611&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e1b611",
  null
  
)

export default component.exports